import { DropdownItem, FilterItem } from '@treezor/design-system';

import { RenderSelectedValues } from '@/ui-kit/table-filters/RenderSelectedValues';
import { ISelectField } from '@/ui-kit/table-filters/filters.type';

export interface ISelectFilterProps {
  field: ISelectField;
  label?: string;
  isFilled?: boolean;
  className?: string;
  testId?: string;
}

export function SelectFilter({ field, label, isFilled = true, className, testId }: ISelectFilterProps) {
  return (
    <FilterItem
      type="CUSTOM"
      id="select"
      renderSelectedValues={(closeDropDown) => (
        <RenderSelectedValues
          label={label}
          values={!!field.value ? [field.value?.label] : undefined}
          onReset={
            isFilled
              ? () => {
                  closeDropDown();
                  field.handleChange(null);
                }
              : undefined
          }
        />
      )}
      testId={testId}
      dropdownContent={(closeDropDown) =>
        field.options.map((option) => (
          <DropdownItem
            key={`option-${option.label}`}
            label={option.label}
            onClick={() => {
              closeDropDown();
              const optionValue = Number.isNaN(Number(option.value)) ? option.value : Number(option.value);
              field.handleChange(optionValue);
            }}
            testId={`dropdown-item-${option.value}`}
          />
        ))
      }
      className={className}
    />
  );
}
